import { Component } from '@angular/core';

@Component({
  selector: 'app-auht-layout-component',
  templateUrl: './auht-layout-component.component.html',
  styleUrl: './auht-layout-component.component.css'
})
export class AuhtLayoutComponent {

}
